import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiBabyGeneratorConfig } from '@/data/landingConfig/landingAiBabyGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiBabyGenerator } from './schemaObject';

interface Props {}
const AiBabyGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiBabyGenerator} />
			<LandingTemplate
				data={landingAiBabyGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiBabyGenerator()}
			/>
		</>
	);
};

export default AiBabyGenerator;
